import { ContainerListContext } from '@/context/ContainersListContext'
import { LoadingButton } from '@mui/lab'
import { Box, CircularProgress, Grid } from '@mui/material'
import { useContext } from 'react'
import ContainerGridItem from './ContainerGridItem'
import { Container } from '@/types'

interface ContainersGridProps {
  onClick: (item: Container) => void
}
const ContainersGrid = ({ onClick }: ContainersGridProps) => {
  const { items, loading, loadNextPageData, canLoadNextPage, loadingNextPage } =
    useContext(ContainerListContext)
  return (
    <Box flexDirection={'column'} display={'flex'} flex={1}>
      {loading && (
        <Box mt={1} display='flex' justifyContent={'center'}>
          <CircularProgress />
        </Box>
      )}
      <Box
        flex={1}
        display={'flex'}
        flexDirection={'column'}
        width={'100%'}
        sx={{ overflow: 'auto' }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            overflow: 'visible',
            padding: '16px',
          }}
        >
          {(items || []).map((item, index) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              lg={2}
              key={item.userID}
              sx={{
                overflow: 'visible',
                padding: '8px !important',
              }}
            >
              <ContainerGridItem item={item} onClick={onClick} />
            </Grid>
          ))}
        </Grid>
      </Box>
      {items && items.length > 0 && canLoadNextPage && (
        <Box m={4} display='flex' justifyContent={'center'}>
          <LoadingButton
            variant='contained'
            onClick={loadNextPageData}
            loading={loadingNextPage}
            disabled={!canLoadNextPage}
            sx={{
              background: loadingNextPage
                ? 'rgba(248, 250, 252, 0.8)'
                : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '1px solid rgba(226, 232, 240, 0.8)',
              color: '#475569',
              padding: '10px 28px',
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '14px',
              letterSpacing: '-0.01em',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                background: loadingNextPage
                  ? 'rgba(248, 250, 252, 0.8)'
                  : 'linear-gradient(135deg, #ffffff 0%, #ffffff 100%)',
                borderColor: '#cbd5e1',
                transform: loadingNextPage ? 'none' : 'translateY(-2px)',
                boxShadow: loadingNextPage
                  ? '0 2px 8px rgba(0, 0, 0, 0.04)'
                  : '0 4px 16px rgba(0, 0, 0, 0.08)',
              },
              '&:active': {
                transform: loadingNextPage ? 'none' : 'translateY(0)',
              },
              '&:disabled': {
                background: 'rgba(248, 250, 252, 0.8)',
                color: '#cbd5e1',
              },
            }}
          >
            Load More Folders
          </LoadingButton>
        </Box>
      )}
    </Box>
  )
}

export default ContainersGrid
